import Vue from "vue";

import VueClipboard from "vue-clipboard2";

export default () => {
  VueClipboard.config.autoSetContainer = true;
  Vue.use(VueClipboard);
};
